// @ts-nocheck
class PdpStickyCart extends HTMLElement {
  connectedCallback() {
    this.targets = document.querySelectorAll('.pdp-add-to-cart');
    this.stickyButton = this.querySelector('[data-ps-sticky-add-to-cart]');
    this.stickyTitle = this.querySelector('[data-ps-sticky-title]');
    this.stickyImage = this.querySelector('[data-ps-sticky-image]');
    this.packsContainer = this.querySelector('[data-ps-sticky-packs]');
    this.subscribeRoot = this.querySelector('[data-ps-sticky-subscribe]');
    this.subscribeInput = this.querySelector('[data-ps-sticky-subscribe-toggle]');
    this.deliveryRoot = this.querySelector('[data-ps-sticky-delivery]');
    this.deliveryTrigger = this.querySelector('[data-ps-sticky-delivery-trigger]');
    this.deliveryText = this.querySelector('[data-ps-sticky-delivery-text]');
    this.deliveryList = this.querySelector('[data-ps-sticky-delivery-list]');

    this.defaultStickyTitle = this.stickyTitle ? this.stickyTitle.textContent : '';
    this.defaultStickyLabel = this.stickyButton ? this.stickyButton.textContent : 'ADD TO CART';
    this.moneyFormat = this._resolveMoneyFormat();
    this.shouldShowByIntersection = false;
    this.aboveViewport = new Set();
    this.varietyActive = false;
    this.bundleReady = false;
    this.bundleQty = 0;
    this.bundleTotalCents = 0;
    this.singleQty = 1;
    this.singleUnitPriceCents = this._getSingleUnitPriceFromDOM();
    this.isLoading = false;
    this.loadingTimeout = null;
    this.isDeliveryOpen = false;

    this.onCartDone = () => {
      this._setLoading(false);
    };

    this.onPackModeChange = (event) => {
      const detail = event?.detail || {};
      if (typeof detail.varietyActive === 'boolean') {
        this.varietyActive = detail.varietyActive;
      }

      if (this.varietyActive) {
        this.bundleReady = this._resolveBundleReadyFromDOM();
        this.bundleTotalCents = this._resolveBundleTotalFromDOM();
      }

      this._applyVisibility();
      this._applyVarietyVisibility();
      this._renderStickyLabel();
    };

    this.onBundleStateChange = (event) => {
      const detail = event?.detail || {};

      if (Number.isInteger(detail.quantity)) {
        this.bundleQty = detail.quantity;
      }

      if (typeof detail.ready === 'boolean') {
        this.bundleReady = detail.ready;
      }

      if (Number.isInteger(detail.totalCents)) {
        this.bundleTotalCents = detail.totalCents;
      }

      this._applyVisibility();
      this._renderStickyLabel();
    };

    this.onSingleStateChange = (event) => {
      const detail = event?.detail || {};

      if (Number.isInteger(detail.quantity) && detail.quantity > 0) {
        this.singleQty = detail.quantity;
      }

      if (Number.isInteger(detail.unitPriceCents) && detail.unitPriceCents >= 0) {
        this.singleUnitPriceCents = detail.unitPriceCents;
      }

      this._syncStickyTitle();
      this._syncSubscribeAvailability();
      this._renderStickyLabel();
    };

    this.onActiveProductChange = (event) => {
      const detail = event?.detail || {};
      if (typeof detail.title === 'string' && detail.title.trim()) {
        this.currentStickyTitle = detail.title.trim();
      }

      if (
        this.stickyImage instanceof HTMLImageElement &&
        typeof detail.heroImage === 'string' &&
        detail.heroImage
      ) {
        this.stickyImage.src = detail.heroImage;
        if (this.currentStickyTitle) {
          this.stickyImage.alt = this.currentStickyTitle;
        }
      }

      this._syncStickyTitle();
      if (!(typeof detail.heroImage === 'string' && detail.heroImage)) {
        this._syncStickyImage();
      }
      this._renderStickyLabel();
    };

    document.addEventListener('cart:update', this.onCartDone);
    document.addEventListener('cart:error', this.onCartDone);
    document.addEventListener('pdp:pack-mode-change', this.onPackModeChange);
    document.addEventListener('pdp:bundle-state-change', this.onBundleStateChange);
    document.addEventListener('pdp:single-state-change', this.onSingleStateChange);
    document.addEventListener('pdp:active-product-change', this.onActiveProductChange);

    if (this.stickyButton) {
      this.onStickyClick = () => {
        if (this.varietyActive && !this.bundleReady) return;

        const activeButton = this._getActiveAddToCartButton();
        if (!activeButton || activeButton.disabled) return;

        this._setLoading(true);
        activeButton.click();
      };

      this.stickyButton.addEventListener('click', this.onStickyClick);
    }

    this._wirePackPills();
    this._wireSubscribeToggle();
    this._wireDeliverySelect();
    this._wireMirrorObservers();
    this._rebuildPackPillsFromMain();

    if (this.targets.length) {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.aboveViewport.delete(entry.target);
            } else if (entry.boundingClientRect.top < 0) {
              this.aboveViewport.add(entry.target);
            } else {
              this.aboveViewport.delete(entry.target);
            }
          });
          this.shouldShowByIntersection = this.aboveViewport.size > 0;
          this._applyVisibility();
        },
        { threshold: 0 }
      );

      this.targets.forEach((el) => this.observer.observe(el));
    }

    this.bundleReady = this._resolveBundleReadyFromDOM();
    this.bundleTotalCents = this._resolveBundleTotalFromDOM();
    this._syncStickyTitle();
    this._syncStickyImage();
    this._syncSubscribeAvailability();
    this._syncSubscribeFromMain();
    this._syncDeliveryFromMain();
    this._applyVarietyVisibility();
    this._renderStickyLabel();
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.packsObserver) this.packsObserver.disconnect();
    if (this.deliveryObserver) this.deliveryObserver.disconnect();
    this.aboveViewport.clear();

    if (this.stickyButton && this.onStickyClick) {
      this.stickyButton.removeEventListener('click', this.onStickyClick);
    }

    document.removeEventListener('cart:update', this.onCartDone);
    document.removeEventListener('cart:error', this.onCartDone);
    document.removeEventListener('pdp:pack-mode-change', this.onPackModeChange);
    document.removeEventListener('pdp:bundle-state-change', this.onBundleStateChange);
    document.removeEventListener('pdp:single-state-change', this.onSingleStateChange);
    document.removeEventListener('pdp:active-product-change', this.onActiveProductChange);

    if (this.onMainRadioChange) {
      document.removeEventListener('change', this.onMainRadioChange, true);
    }
    if (this.onOutsideDeliveryClick) {
      document.removeEventListener('click', this.onOutsideDeliveryClick);
    }

    if (this.loadingTimeout) {
      clearTimeout(this.loadingTimeout);
      this.loadingTimeout = null;
    }
  }

  /* ── Pack pills delegation ─────────────────────────────────── */
  _wirePackPills() {
    if (!this.packsContainer) return;

    this.packsContainer.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const button = target ? target.closest('[data-ps-sticky-pack]') : null;
      if (!button || !this.packsContainer.contains(button)) return;

      const pack = button.dataset.pack || '';
      const variantId = button.dataset.variantId;
      if (!pack && !variantId) return;

      const escapedPack = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(pack) : pack.replace(/"/g, '\\"');
      const escapedVariantId = typeof CSS !== 'undefined' && CSS.escape
        ? CSS.escape(String(variantId || ''))
        : String(variantId || '').replace(/"/g, '\\"');

      const mainBtn = document.querySelector(
        pack
          ? `.product-spotlight__pack-option[data-pack="${escapedPack}"]`
          : `.product-spotlight__pack-option[data-variant-id="${escapedVariantId}"]`
      );
      if (mainBtn instanceof HTMLElement) {
        mainBtn.click();
      }

      this._setActivePackPill(pack, variantId);
    });
  }

  _setActivePackPill(pack, variantId) {
    if (!this.packsContainer) return;
    const pills = this.packsContainer.querySelectorAll('[data-ps-sticky-pack]');
    pills.forEach((pill) => {
      const isActiveByPack = pack && pill.dataset.pack === String(pack);
      const isActiveByVariant = !pack && pill.dataset.variantId === String(variantId || '');
      pill.classList.toggle(
        'pdp-sticky-cart__pack--active',
        Boolean(isActiveByPack || isActiveByVariant)
      );
    });
  }

  _rebuildPackPillsFromMain() {
    if (!this.packsContainer) return;
    const mainPacks = document.querySelector('.product-spotlight__pack-options');
    if (!mainPacks) return;
    const mainButtons = mainPacks.querySelectorAll('[data-ps-pack-variant]');
    if (!mainButtons.length) {
      this.packsContainer.innerHTML = '';
      return;
    }

    const html = Array.from(mainButtons).map((btn) => {
      const isActive = btn.classList.contains('product-spotlight__pack-option--active');
      const variantId = btn.dataset.variantId || '';
      const pack = btn.dataset.pack || '';
      const spans = btn.querySelectorAll('span');
      const labelTop = spans[0] ? spans[0].textContent : '';
      const labelBottom = spans[1] ? spans[1].textContent : '';
      return (
        `<button class="pdp-sticky-cart__pack${isActive ? ' pdp-sticky-cart__pack--active' : ''}"` +
        ` type="button" data-ps-sticky-pack data-variant-id="${this._escapeAttr(variantId)}" data-pack="${this._escapeAttr(pack)}">` +
        `<span>${this._escapeHtml(labelTop)}</span>` +
        `<span>${this._escapeHtml(labelBottom)}</span>` +
        `</button>`
      );
    }).join('');

    this.packsContainer.innerHTML = html;
  }

  /* ── Subscribe toggle delegation ──────────────────────────── */
  _wireSubscribeToggle() {
    if (!this.subscribeInput) return;

    this.subscribeInput.addEventListener('change', () => {
      const target = this.subscribeInput.checked ? 'subscribe' : 'one-time';
      const radio = document.querySelector(
        `input.product-spotlight__radio[value="${target}"]`
      );
      if (radio instanceof HTMLInputElement && !radio.disabled) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        // Revert if not allowed (e.g. subscribe disabled)
        this.subscribeInput.checked = !this.subscribeInput.checked;
      }
    });

    this.onMainRadioChange = (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (!target.classList.contains('product-spotlight__radio')) return;
      this._syncSubscribeFromMain();
      this._renderStickyLabel();
    };
    document.addEventListener('change', this.onMainRadioChange, true);
  }

  _syncSubscribeFromMain() {
    if (!this.subscribeInput) return;
    const subscribeRadio = document.querySelector(
      'input.product-spotlight__radio[value="subscribe"]'
    );
    const checked = subscribeRadio instanceof HTMLInputElement && subscribeRadio.checked;
    if (this.subscribeInput.checked !== checked) {
      this.subscribeInput.checked = checked;
    }
  }

  _syncSubscribeAvailability() {
    const subscribeOption = document.querySelector('[data-ps-subscribe-option]');
    const visible = subscribeOption instanceof HTMLElement
      ? !(subscribeOption.style.display === 'none')
      : false;

    if (this.subscribeRoot) {
      this.subscribeRoot.toggleAttribute('hidden', !visible);
    }
    if (this.deliveryRoot) {
      this.deliveryRoot.toggleAttribute('hidden', !visible);
    }

    if (!visible && this.subscribeInput && this.subscribeInput.checked) {
      this.subscribeInput.checked = false;
    }
  }

  /* ── Delivery select delegation ───────────────────────────── */
  _wireDeliverySelect() {
    if (!this.deliveryRoot || !this.deliveryTrigger || !this.deliveryList) return;

    this.deliveryTrigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this._toggleDelivery();
    });

    this.deliveryList.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const option = target ? target.closest('.pdp-sticky-cart__delivery-option') : null;
      if (!option || !this.deliveryList.contains(option)) return;

      const sellingPlanId = option.dataset.sellingPlanId;
      if (!sellingPlanId) return;

      const mainOption = document.querySelector(
        `.product-spotlight__delivery-option[data-selling-plan-id="${sellingPlanId}"]`
      );
      if (mainOption instanceof HTMLElement) {
        mainOption.click();
      }

      this._closeDelivery();
    });

    this.onOutsideDeliveryClick = (event) => {
      if (!this.isDeliveryOpen) return;
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      if (this.deliveryRoot && this.deliveryRoot.contains(target)) return;
      this._closeDelivery();
    };
    document.addEventListener('click', this.onOutsideDeliveryClick);
  }

  _toggleDelivery() {
    if (this.isDeliveryOpen) {
      this._closeDelivery();
    } else {
      this._openDelivery();
    }
  }

  _openDelivery() {
    if (!this.deliveryList || !this.deliveryTrigger) return;
    this.deliveryList.hidden = false;
    this.deliveryTrigger.setAttribute('aria-expanded', 'true');
    this.isDeliveryOpen = true;
  }

  _closeDelivery() {
    if (!this.deliveryList || !this.deliveryTrigger) return;
    this.deliveryList.hidden = true;
    this.deliveryTrigger.setAttribute('aria-expanded', 'false');
    this.isDeliveryOpen = false;
  }

  _syncDeliveryFromMain() {
    if (!this.deliveryList) return;
    const mainList = document.querySelector('[data-ps-delivery-options]');
    if (!(mainList instanceof HTMLElement)) return;

    const mainOptions = mainList.querySelectorAll('.product-spotlight__delivery-option');
    if (!mainOptions.length) {
      this.deliveryList.innerHTML = '';
      if (this.deliveryText) this.deliveryText.textContent = 'Deliver every 1 Month';
      return;
    }

    const html = Array.from(mainOptions).map((opt) => {
      const id = opt.dataset.sellingPlanId || '';
      const isSelected = opt.classList.contains('product-spotlight__delivery-option--selected');
      const text = String(opt.textContent || '').trim();
      return (
        `<li class="pdp-sticky-cart__delivery-option${isSelected ? ' pdp-sticky-cart__delivery-option--selected' : ''}"` +
        ` role="option" aria-selected="${isSelected ? 'true' : 'false'}"` +
        ` data-selling-plan-id="${this._escapeAttr(id)}">` +
        this._escapeHtml(text) +
        `</li>`
      );
    }).join('');

    this.deliveryList.innerHTML = html;

    const selected = Array.from(mainOptions).find((o) =>
      o.classList.contains('product-spotlight__delivery-option--selected')
    ) || mainOptions[0];
    if (selected && this.deliveryText) {
      this.deliveryText.textContent = String(selected.textContent || '').trim();
    }
  }

  /* ── Mirror observers (main UI -> sticky) ─────────────────── */
  _wireMirrorObservers() {
    const mainPacks = document.querySelector('.product-spotlight__pack-options');
    if (mainPacks) {
      this.packsObserver = new MutationObserver(() => {
        this._rebuildPackPillsFromMain();
      });
      this.packsObserver.observe(mainPacks, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        subtree: true,
      });
    }

    const mainDelivery = document.querySelector('[data-ps-delivery-options]');
    if (mainDelivery) {
      this.deliveryObserver = new MutationObserver(() => {
        this._syncDeliveryFromMain();
      });
      this.deliveryObserver.observe(mainDelivery, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        subtree: true,
      });
    }
  }

  /* ── Image / title sync ───────────────────────────────────── */
  _syncStickyImage() {
    if (!this.stickyImage) return;
    const heroImg = document.querySelector('[data-ps-hero-img]');
    if (heroImg instanceof HTMLImageElement && heroImg.src) {
      this.stickyImage.src = heroImg.src;
      if (heroImg.alt) this.stickyImage.alt = heroImg.alt;
    }
  }

  /* ── Loading + label ──────────────────────────────────────── */
  _setLoading(isLoading) {
    if (!this.stickyButton) return;

    if (isLoading) {
      this.isLoading = true;
      this.stickyButton.disabled = true;
      this.stickyButton.textContent = 'ADDING...';

      if (this.loadingTimeout) clearTimeout(this.loadingTimeout);

      this.loadingTimeout = setTimeout(() => {
        this._setLoading(false);
      }, 5000);

      return;
    }

    this.isLoading = false;
    this.stickyButton.disabled = false;
    this._renderStickyLabel();

    if (this.loadingTimeout) {
      clearTimeout(this.loadingTimeout);
      this.loadingTimeout = null;
    }
  }

  _isVisible(el) {
    if (!(el instanceof HTMLElement)) return false;
    if (el.hidden) return false;
    if (el.closest('[hidden]')) return false;
    if (el.closest('[style*="display:none"], [style*="display: none"]')) return false;
    return true;
  }

  _getActiveAddToCartButton() {
    const targets = Array.from(document.querySelectorAll('.pdp-add-to-cart'));
    const visibleEnabled = targets.find((el) => this._isVisible(el) && !el.disabled);
    if (visibleEnabled instanceof HTMLButtonElement) return visibleEnabled;

    const visible = targets.find((el) => this._isVisible(el));
    if (visible instanceof HTMLButtonElement) return visible;

    const fallback = targets[0];
    return fallback instanceof HTMLButtonElement ? fallback : null;
  }

  _applyVisibility() {
    const canShow = this.varietyActive ? this.bundleReady : true;
    this.classList.toggle('is-visible', this.shouldShowByIntersection && canShow);
  }

  _applyVarietyVisibility() {
    // Hide variant-driven controls when variety/bundle mode is active.
    const hide = this.varietyActive;
    if (this.packsContainer) this.packsContainer.toggleAttribute('hidden', hide);
    if (this.subscribeRoot && !hide) {
      // restored by _syncSubscribeAvailability based on current variant's selling plans
      this._syncSubscribeAvailability();
    } else if (this.subscribeRoot) {
      this.subscribeRoot.toggleAttribute('hidden', true);
    }
    if (this.deliveryRoot) this.deliveryRoot.toggleAttribute('hidden', hide || (this.subscribeRoot && this.subscribeRoot.hasAttribute('hidden')));
  }

  _renderStickyLabel() {
    if (!this.stickyButton || this.isLoading) return;

    this._syncStickyTitle();

    if (this.varietyActive) {
      const totalText = this._formatMoney(Math.max(this.bundleTotalCents, 0));
      this.stickyButton.textContent = `ADD TO CART ${totalText}`;
      return;
    }

    const subscribePriceCents = this._resolveSubscribePriceCents();
    const isSubscribe = this.subscribeInput && this.subscribeInput.checked && subscribePriceCents > 0;

    if (isSubscribe) {
      const totalCents = subscribePriceCents * Math.max(this.singleQty, 1);
      this.stickyButton.textContent = `ADD TO CART ${this._formatMoney(totalCents)}`;
      return;
    }

    if (!this.singleUnitPriceCents || this.singleUnitPriceCents <= 0) {
      this.singleUnitPriceCents = this._getSingleUnitPriceFromDOM();
    }

    const totalCents = Math.max(this.singleUnitPriceCents, 0) * Math.max(this.singleQty, 1);
    if (totalCents > 0) {
      this.stickyButton.textContent = `ADD TO CART ${this._formatMoney(totalCents)}`;
      return;
    }

    this.stickyButton.textContent = this.defaultStickyLabel;
  }

  _syncStickyTitle() {
    if (!this.stickyTitle) return;

    const urlTitle = this._resolveStickyTitleFromURL();
    if (urlTitle) {
      this.stickyTitle.textContent = urlTitle;
      return;
    }

    if (typeof this.currentStickyTitle === 'string' && this.currentStickyTitle) {
      this.stickyTitle.textContent = this.currentStickyTitle;
      return;
    }

    const activeTitle = this._resolveActiveProductTitleFromDOM();
    if (activeTitle) {
      this.stickyTitle.textContent = activeTitle;
      return;
    }

    this.stickyTitle.textContent = this.defaultStickyTitle;
  }

  _resolveStickyTitleFromURL() {
    const handle = this._resolveProductHandleFromPath();
    if (!handle) return '';

    const selectorHandle = typeof CSS !== 'undefined' && CSS.escape
      ? CSS.escape(handle)
      : handle.replace(/"/g, '\\"');

    const flavorOption = document.querySelector(
      `.product-spotlight__flavor-option[data-flavor="${selectorHandle}"]`
    );

    if (!(flavorOption instanceof HTMLElement)) return '';

    const dataScript = flavorOption.querySelector('.ps-flavor-data');
    if (dataScript instanceof HTMLScriptElement) {
      try {
        const data = JSON.parse(dataScript.textContent || '{}');
        if (typeof data.title === 'string' && data.title.trim()) {
          return data.title.trim();
        }
      } catch (error) {
        console.warn('[PdpStickyCart] Failed parsing flavor data for title', error);
      }
    }

    const labelEl = flavorOption.querySelector('.product-spotlight__flavor-label');
    return labelEl instanceof HTMLElement ? String(labelEl.textContent || '').trim() : '';
  }

  _resolveProductHandleFromPath() {
    const match = window.location.pathname.match(/^\/products\/([^/]+)/i);
    if (!match || !match[1]) return '';

    try {
      return decodeURIComponent(match[1]).trim();
    } catch (_error) {
      return String(match[1]).trim();
    }
  }

  _resolveActiveProductTitleFromDOM() {
    const titleEl = document.querySelector('[data-ps-title]');
    if (!(titleEl instanceof HTMLElement)) return '';
    return String(titleEl.textContent || '').trim();
  }

  _resolveMoneyFormat() {
    const spotlight = document.querySelector('product-spotlight');
    if (spotlight instanceof HTMLElement && spotlight.dataset.moneyFormat) {
      return spotlight.dataset.moneyFormat;
    }
    return '${{amount}}';
  }

  _formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return this.moneyFormat
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', String(Math.round(cents / 100)));
  }

  _resolveBundleReadyFromDOM() {
    const btn = document.querySelector('[data-ps-variety-only]:not([style*="display:none"]):not([style*="display: none"]) [data-bb-add-to-cart]')
      || document.querySelector('[data-bb-add-to-cart]');
    return btn instanceof HTMLButtonElement && btn.dataset.ready === 'true';
  }

  _resolveBundleTotalFromDOM() {
    const totalEl = document.querySelector('[data-ps-variety-only]:not([style*="display:none"]):not([style*="display: none"]) [data-bb-discounted-price]')
      || document.querySelector('[data-bb-discounted-price]');
    if (!(totalEl instanceof HTMLElement)) return 0;
    return this._parseMoneyToCents(totalEl.textContent || '');
  }

  _getSingleUnitPriceFromDOM() {
    const priceEl = document.querySelector('[data-ps-price]');
    if (!(priceEl instanceof HTMLElement)) return 0;
    return this._parseMoneyToCents(priceEl.textContent || '');
  }

  _resolveSubscribePriceCents() {
    const priceEl = document.querySelector('[data-ps-subscribe-price]');
    if (!(priceEl instanceof HTMLElement)) return 0;
    return this._parseMoneyToCents(priceEl.textContent || '');
  }

  _parseMoneyToCents(rawText) {
    const text = String(rawText || '').trim();
    if (!text) return 0;

    const cleaned = text.replace(/[^\d.,-]/g, '');
    if (!cleaned) return 0;

    const lastComma = cleaned.lastIndexOf(',');
    const lastDot = cleaned.lastIndexOf('.');
    const sepIndex = Math.max(lastComma, lastDot);

    if (sepIndex === -1) {
      const intVal = parseInt(cleaned.replace(/[^\d-]/g, ''), 10);
      return Number.isNaN(intVal) ? 0 : intVal * 100;
    }

    const intPart = cleaned.slice(0, sepIndex).replace(/[^\d-]/g, '');
    const decPart = cleaned.slice(sepIndex + 1).replace(/[^\d]/g, '').slice(0, 2).padEnd(2, '0');
    const combined = `${intPart}${decPart}`;
    const cents = parseInt(combined, 10);
    return Number.isNaN(cents) ? 0 : cents;
  }

  _escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  _escapeAttr(str) {
    return this._escapeHtml(str);
  }
}

if (!customElements.get('pdp-sticky-cart')) {
  customElements.define('pdp-sticky-cart', PdpStickyCart);
}
